module.exports = __webpack_public_path__ + "img/logos/loom-connect-logo-9a8b1df5c919cf7131b0112c4a2fab43.svg";